import domready from 'domready'
import VideoCoverController from './controllers/video-cover-controller'

export default function initVideoCovers () {
  domready(() => {
    const videoPlayerElements = document.querySelectorAll('.video-player')
    ;[].forEach.call(videoPlayerElements, (element) => {
      // eslint-disable-next-line no-new
      new VideoCoverController(element)
    })
  })
}
